import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useRouter } from 'next/navigation';

import { useAuth } from '@flipster/features/src/shared/auth/state';
import { launchpoolItemBunja } from '@flipster/features/src/shared/launchpool/state';
import { useOverlay } from '@flipster/overlay';
import { Button } from '@flipster/react/design-system';
import InformationCircleIcon from '@flipster/react/icon/generated/InformationCircleIcon';
import { css } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';
import { token } from '@flipster/styled-system/tokens';
import { UsdtCurrency } from '@flipster/utils/constants/currency';
import segment from '@flipster/utils/segment';
import { StakeEvent } from '@flipster/utils/segment/events/stake';

import { useWalletModal } from '@web/app/[locale]/(web)/_modal/WalletModal/hooks/useWalletModal';
import ConvertInfoModal from '@web/app/[locale]/(web)/launchpool/_modals/ConvertInfoModal';

const ConvertInfo = () => {
  const router = useRouter();
  const overlay = useOverlay();
  const { launchpoolItemAtom } = useBunja(launchpoolItemBunja);
  const launchpool = useAtomValue(launchpoolItemAtom);

  const { isLoggedIn } = useAuth();
  const { openWalletModal } = useWalletModal();

  const onClickConvert = () => {
    segment.track(StakeEvent.StakeConvertToUsdtClick);
    if (!isLoggedIn) {
      router.push('/signin');
      return;
    }

    openWalletModal('convert', { defaultCurrency: launchpool.stakingCurrency, defaultToCurrency: UsdtCurrency });
  };

  return (
    <div
      className={hstack({
        justify: 'space-between',
        gap: 8,
        mb: 8,
        py: 12,
        px: 16,
        bgColor: 'background.default.level-1',
        rounded: 8,
      })}
    >
      <div
        className={css({
          textStyle: 'Text/M/Regular',
          display: 'flex',
          flexDirection: { base: 'column', tablet: 'row' },
        })}
      >
        <span className={css({ color: 'content.default.level-4' })}>{launchpool.conversionTooltip.title}&nbsp;</span>
        <span className={css({ color: 'content.state.positive' })}>
          {launchpool.conversionTooltip.highlightedTitle}
          <button
            type='button'
            onClick={() => overlay.open((close) => <ConvertInfoModal launchpoolId={launchpool.id} onClose={close} />)}
            className={css({ buttonShape: 'inline-icon', ml: 4 })}
          >
            <InformationCircleIcon size={16} color={token('colors.content.default.level-1')} />
          </button>
        </span>
      </div>
      <Button
        hierarchy='primary'
        color='accent'
        size='medium'
        label='Convert'
        onClick={onClickConvert}
        css={{ w: 78 }}
      />
    </div>
  );
};

export default ConvertInfo;
